export default __webpack_public_path__ + "static/media/sales_performance_filled_500px.34572f33.png";